import React from "react";
import { Form } from "react-bootstrap";
import { usePlacesWidget } from "react-google-autocomplete";
import { handlePlaceSelect } from "../common/utils";
import { StatesOption } from "../components/enrollment/StepServiceUsn";

const AddressAutoCompleteForUsn = ({
  address,
  setAddress,
  loading,
  setCity,
  setSelectedCounty,
  setUnitNo,
  setSelectedState,
  setUsnZipCodeInput,
}: {
  address: string;
  setAddress: (val: string) => void;
  loading: boolean;
  setCity: (val: string) => void;
  setSelectedCounty: (val: string) => void;
  setUnitNo: (val: string) => void;
  setSelectedState: React.Dispatch<
    React.SetStateAction<StatesOption | undefined>
  >;
  setUsnZipCodeInput: (val: string) => void;
}) => {
  const { ref } = usePlacesWidget<HTMLInputElement>({
    apiKey: "AIzaSyAcGkZI81wg0GRI5x46cPUSKPn_uzBfmuQ",
    options: {
      types: ["address"],
      componentRestrictions: { country: "us" },
    },
    onPlaceSelected: (place) => {
      console.log({ place });
      const fields = handlePlaceSelect(place);
      const {
        responseState,
        responseCounty,
        responseCity,
        responseZipCode,
        responseUnitNo,
        responseAddressLine,
      } = fields;
      console.log({ fields });
      setAddress(responseAddressLine);
      setCity(responseCity);
      setUsnZipCodeInput(responseZipCode);
      setSelectedCounty(responseCounty);
      setUnitNo(responseUnitNo);
      setSelectedState(responseState);
    },
  });
  return (
    <Form.Control
      ref={ref}
      type="text"
      name="service_address"
      placeholder=""
      maxLength={200}
      value={address}
      onChange={(evt) => setAddress(evt.target.value)}
      disabled={loading}
    />
  );
};

export default AddressAutoCompleteForUsn;
